<script>
import proofCreated from "./modal-proof-created.vue";
import { MODAL_NAMES } from "../../utils/constants";

export default {
    name: "onboardingTodosModal",
    components: {
        proofCreated
    },
    data() {
        return {
            MODAL_NAMES
        };
    },
    props: {
        todos: {
            type: Array,
            default: () => []
        },
        isProofCreated: {
            type: Boolean,
            default: false
        },
        currentOnboardingStep: {
            type: Object,
            required: true
        },
    },
    mounted() {
        this.$bvModal.show(MODAL_NAMES.ONBOARDING_MODEL);
        this.fireConfetti();
    },
    methods: {
        closeModal() {
            this.$bvModal.hide(MODAL_NAMES.ONBOARDING_MODEL);
            if (this.isProofCreated) {
                this.$bvModal.show(MODAL_NAMES.PROOF_CREATED);
            }
        },
        enableBodyScroll() {
            document.body.style.overflow = "auto";
        },
        fireConfetti() {
            this.$confetti.start({
                particles: [
                    {
                        type: 'heart',
                    },
                    {
                        type: 'circle',
                    },
                    {
                        type: 'rect',
                    }
                ],
                defaultDropRate: 20,
                particlesPerFrame: 8,
            });
            setTimeout(() => {
                this.$confetti.stop();
            }, 1800);
        }
    }
};
</script>

<template>
    <b-modal :id="MODAL_NAMES.ONBOARDING_MODEL" size="lg" hide-footer hide-header centered no-stacking no-close-on-backdrop
        no-enforce-focus lazy content-class="custom-modal-content" modal-class="custom-modal-wrapper"
        @shown="enableBodyScroll">
        <div class="text-center">
            <p class="onboarding-badge mb-20">Onboarding Step Complete!</p>
            <h2 class="ff-montserrat mb-20 text-gray-900 fs-sm-24">{{ currentOnboardingStep.headingIcon }}
                {{ currentOnboardingStep.heading }}</h2>
            <p class="fs-14 mb-20 text-gray-600 fs-sm-12">{{ currentOnboardingStep.subHeading }}</p>
        </div>
        <template v-if="todos.length > 0">
            <h5 class="text-left ff-montserrat NextText mb-3">What's Next?</h5>
            <div class="next-steps-box border-gray-300 mt-0 rounded-3 overflow-hidden">
                <div v-for="(todo, idx) in todos" :key="`todo-${idx}`">
                    <div class="step-box d-flex align-items-start">
                        <div class="icon-wrapper border-gray-300 mr-3 mr-md-4 p-2">
                            <img :src="`/img/${todo.icon}`" :alt="todo.title" class="task-icon-img" />
                        </div>
                        <div class="flex-grow-1">
                            <strong class="stepText text-gray-900">{{ todo.title }}</strong>
                            <p class="step-desc text-gray-500 mt-1 mb-0 fs-sm-12">
                                {{ todo.description }}
                            </p>
                        </div>
                        <span class="step-time bg-gray-100">{{ todo.duration }}</span>
                    </div>
                    <hr v-if="idx < todos.length - 1" class="step-divider border-gray-300" />
                </div>
            </div>
        </template>
        <div class="button-container">
            <b-button class="button-green action-btn" @click="closeModal">Let's Go!</b-button>
        </div>
    </b-modal>
</template>

<style scoped>
.modal-open {
    overflow: hidden !important;
}

.modal-open .modal {
    overflow: hidden !important;
}

::v-deep .custom-modal-wrapper {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: auto !important;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
}

::v-deep .custom-modal-content {
    height: auto;
    padding: 32px;
    margin: auto;
    max-height: 90vh;
    overflow-y: auto;
}

.onboarding-badge {
    background-color: #D1F6D4;
    color: #264C29;
    padding: 2px 10px;
    border-radius: 10px;
    font-weight: 400;
    font-size: 12px;
    display: inline-block;
}

.modal-title {
    font-size: 30px;
    font-weight: 700;
    color: #252526;
}

.NextText {
    font-weight: bold;
    color: #252526;
    font-size: 20px;
}

.stepText {
    font-weight: bold;
    font-size: 16px;
}

.next-steps-box {
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
}

.step-box {
    background: white;
    padding: 16px 24px;
    display: flex;
    align-items: flex-start;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
}

.icon-wrapper {
    background: #F0F9F4;
    border-radius: 10px;
    border: 1px dashed;
    display: flex;
    align-items: center;
    justify-content: center;
}

.step-desc {
    font-size: 16px;
}

.step-time {
    color: #252526;
    font-size: 0.75rem;
    padding: 2px 10px;
    white-space: nowrap;
    align-self: start;
    border-radius: 10px;
}

.step-divider {
    border: none;
    border-top: 1px solid;    
    margin: 0;
    width: 100%;
}

.button-container {
    text-align: right;
    margin-top: 20px;
}

.action-btn {
    padding: 9px 17px;
    width: 130px;
}

.task-icon-img {
    width: 24px;
    height: 24px;
    object-fit: contain;
}

@media (max-width: 640px) {
    ::v-deep .custom-modal-content {
        padding: 4px;
        margin: 0px 8px;
    }
    .fs-sm-24 {
        font-size: 24px;
    }

    .fs-sm-12 {
        font-size: 12px;
    }

    .step-box {
        padding: 12px 16px;
    }

    .task-icon-img {
        width: 18px;
        height: 18px;
    }

    .stepText {
        font-size: 12px;
    }

    .step-time {
        font-size: 10px;
    }
}
</style>
